import * as React from 'react';
import ManageHelpDocument from './manage-help-document';
import HelpDocumentManagement from '../../../models/helpDocumentManagement';

const AddClientDocument = () => {
  const defaultDocument = {
    feature: '',
    title: '',
    content: '',
    alternative: '',
    snippetId: -1,
    snippetGroupId: 0,
    revision: 0,
    clientId: -1,
    tags: [],
    dashboards: []
  } as HelpDocumentManagement;

  return <ManageHelpDocument document={defaultDocument} isNewDocument />;
};

export default AddClientDocument;
